export default __webpack_public_path__ + "static/media/AceiteLinaza.32013f10.jpeg";